import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import Swal from "sweetalert2";

class Coupons extends Component {
  state = {
    coupons: [],
    formData: {
      id: null,
      name: "",
      code: "",
      type: "",
      amount: "",
      start_date: "",
      end_date: "",
      status: "",
    },
    deleteId: null,
    error: "",
    loading: false,
    submitting: false,
    modalMode: "add",
  };

  componentDidMount() {
    this.fetchCoupons();

    const modalEl = document.getElementById("couponModal");
    if (modalEl) {
      modalEl.addEventListener("hidden.bs.modal", () => {
        this.setState({
          formData: {
            id: null,
            name: "",
            code: "",
            type: "",
            amount: "",
            start_date: "",
            end_date: "",
            status: "",
          },
          error: "",
          submitting: false,
          modalMode: "add",
        });
      });
    }
  }

  /** ✅ Fetch all coupons */
  fetchCoupons = async () => {
    this.setState({ loading: true, error: "" });
    try {
      const res = await axios.get("/coupons");
      const data = res.data?.data || [];
      this.setState({ coupons: Array.isArray(data) ? data : [] });
    } catch (err) {
      this.setState({
        error: err.response?.data?.message || "Failed to load coupons.",
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  /** ✅ Handle input change */
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      formData: { ...prev.formData, [name]: value },
    }));
  };

  /** ✅ Open modal */
  openModal = (mode = "add", coupon = null) => {
    const modal = new window.bootstrap.Modal(
      document.getElementById("couponModal")
    );

    if (mode === "edit" && coupon) {
      this.setState({
        modalMode: "edit",
        formData: { ...coupon, status: coupon.status?.toString() ?? "0" },
        error: "",
      });
    } else {
      this.setState({
        modalMode: "add",
        formData: {
          id: null,
          name: "",
          code: "",
          type: "",
          amount: "",
          start_date: "",
          end_date: "",
          status: "",
        },
        error: "",
      });
    }

    modal.show();
  };

  /** ✅ Submit form */
  handleSubmit = async (e) => {
    e.preventDefault();
    const { formData, modalMode } = this.state;

    if (!formData.name) return this.setState({ error: "Name is required." });
    if (!formData.code) return this.setState({ error: "Code is required." });
    if (!formData.type) return this.setState({ error: "Type is required." });
    if (!formData.amount) return this.setState({ error: "Amount is required." });
    if (formData.status === "")
      return this.setState({ error: "Status is required." });

    this.setState({ submitting: true, error: "" });

    try {
      const token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };

      if (modalMode === "add") {
        await axios.post("/coupons", formData, { headers });
      } else {
        await axios.put(`/coupons/${formData.id}`, formData, {
          headers,
        });
      }

      await this.fetchCoupons();

      const modal = window.bootstrap.Modal.getInstance(
        document.getElementById("couponModal")
      );
      modal.hide();

      Swal.fire({
        icon: "success",
        title:
          modalMode === "add"
            ? "Coupon added successfully!"
            : "Coupon updated successfully!",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (err) {
      this.setState({
        error:
          err.response?.data?.message ||
          err.response?.data?.error ||
          "Error saving coupon.",
      });
    } finally {
      this.setState({ submitting: false });
    }
  };

  /** ✅ Delete confirmation */
  confirmDelete = (id) => {
    this.setState({ deleteId: id });
    const modal = new window.bootstrap.Modal(
      document.getElementById("deleteModal")
    );
    modal.show();
  };

  /** ✅ Delete coupon */
  handleDelete = async () => {
    const { deleteId } = this.state;
    if (!deleteId) return;

    try {
      const token = localStorage.getItem("token");
      await axios.delete(`/coupons/${deleteId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      await this.fetchCoupons();

      const modal = window.bootstrap.Modal.getInstance(
        document.getElementById("deleteModal")
      );
      modal.hide();

      Swal.fire({
        icon: "success",
        title: "Coupon deleted successfully!",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch {
      Swal.fire({
        icon: "error",
        title: "Failed to delete coupon.",
      });
    }
  };

  render() {
    const { coupons, formData, error, loading, submitting, modalMode } =
      this.state;

    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="row">
            <div className="col-lg-12">
              <div className="card shadow-none">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <ul className="breadcrumb mb-0">
                    <li className="breadcrumb-item">Coupons</li>
                    <li className="breadcrumb-item active">List</li>
                  </ul>
                  <button
                    type="button"
                    className="btn btn-light-warning"
                    onClick={() => this.openModal("add")}
                  >
                    + New Coupon
                  </button>
                </div>

                <div className="card-body">
                  {error && <div className="alert alert-danger">{error}</div>}
                  {loading ? (
                    <div className="text-center py-4">Loading...</div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Code</th>
                            <th>Type</th>
                            <th>Amount</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {coupons.length ? (
                            coupons.map((c, i) => (
                              <tr key={c.id}>
                                <td>{i + 1}</td>
                                <td>{c.name}</td>
                                <td>{c.code}</td>
                                <td>{c.type}</td>
                                <td>{c.amount}</td>
                                <td>{c.start_date}</td>
                                <td>{c.end_date}</td>
                                <td>
                                  {c.status === "1" || c.status === 1 ? (
                                    <span className="badge bg-success">
                                      Active
                                    </span>
                                  ) : (
                                    <span className="badge bg-danger">
                                      Inactive
                                    </span>
                                  )}
                                </td>
                                <td>
                                  <button
                                    className="btn btn-sm btn-light-success me-2"
                                    onClick={() => this.openModal("edit", c)}
                                  >
                                    <i className="ph ph-note-pencil"></i>
                                  </button>
                                  <button
                                    className="btn btn-sm btn-light-danger"
                                    onClick={() => this.confirmDelete(c.id)}
                                  >
                                    <i className="ph ph-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="9" className="text-center">
                                No coupons found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ✅ Add/Edit Modal */}
        <div className="modal fade" id="couponModal" tabIndex={-1}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <form onSubmit={this.handleSubmit}>
                <div className="modal-header">
                  <h5 className="modal-title">
                    {modalMode === "add" ? "Add Coupon" : "Edit Coupon"}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                  ></button>
                </div>

                <div className="modal-body">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label">Name</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        value={formData.name}
                        onChange={this.handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Code</label>
                      <input
                        type="text"
                        name="code"
                        className="form-control"
                        value={formData.code}
                        onChange={this.handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Type</label>
                      <select
                        name="type"
                        className="form-select"
                        value={formData.type}
                        onChange={this.handleChange}
                        required
                      >
                        <option value="">Select Type</option>
                        <option value="fixed">Fixed</option>
                        <option value="percentage">Percentage</option>
                      </select>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Amount</label>
                      <input
                        type="number"
                        name="amount"
                        className="form-control"
                        value={formData.amount}
                        onChange={this.handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Start Date</label>
                      <input
                        type="date"
                        name="start_date"
                        className="form-control"
                        value={formData.start_date}
                        onChange={this.handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">End Date</label>
                      <input
                        type="date"
                        name="end_date"
                        className="form-control"
                        value={formData.end_date}
                        onChange={this.handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Status</label>
                      <select
                        name="status"
                        className="form-select"
                        value={formData.status}
                        onChange={this.handleChange}
                        required
                      >
                        <option value="">Select Status</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div>

                  {error && <div className="alert alert-danger mt-3">{error}</div>}
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-light-danger"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-light-primary"
                    disabled={submitting}
                  >
                    {submitting
                      ? "Saving..."
                      : modalMode === "add"
                      ? "Add"
                      : "Update"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* ✅ Delete Confirmation */}
        <div className="modal fade" id="deleteModal" tabIndex={-1}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-danger">
              <div className="modal-body text-center p-4">
                <i className="ph ph-warning text-danger f-40 mb-3"></i>
                <h5>Are you sure?</h5>
                <p className="text-muted mb-4">This action cannot be undone.</p>
                <div className="d-flex justify-content-center gap-3">
                  <button
                    type="button"
                    className="btn btn-light-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-light-danger"
                    onClick={this.handleDelete}
                  >
                    Yes, Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Coupons;
